import React from "react";
import logo from "../../assets/logo.png";

const Logo = ({ size = 160 }) => (
  <img
    src={logo}
    alt="Logo"
    style={{
      width: size,
      height: "auto",
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: 32,
      marginTop: 32,
      maxWidth: "90vw",
      objectFit: "contain"
    }}
  />
);

export default Logo;
